import checkIsTicketTypeShownInQuery from './checkIsTicketTypeShownInQuery';
import checkIsTicketTypeNotOnSale from './checkIsTicketTypeNotOnSale';

export default function checkIsTicketTypeVisible({
  ticketType = {},
  query = {},
  isSoldOut = false,
  isOnSale,
  isCanceled,
  isUnavailable,
  hasInvalidReference,
  isScheduled,
}) {
  if (ticketType.hidden) {
    const isTicketTypeShownInQuery = checkIsTicketTypeShownInQuery(ticketType.reference, query);

    if (isTicketTypeShownInQuery) return true;

    return false;
  }

  if (isSoldOut && ticketType.hideWhenSoldOut) {
    return false;
  }

  if (ticketType.hideWhenScheduled && isScheduled) {
    return false;
  }

  if (ticketType.hideWhenNotOnSale) {
    const isNotOnSale = checkIsTicketTypeNotOnSale({
      ticketType,
      isCanceled,
      isOnSale,
      isScheduled,
      hasInvalidReference,
    });

    if (isNotOnSale) {
      return false;
    }
  }

  if (ticketType.hideWhenUnavailable && isUnavailable) {
    return false;
  }

  return true;
}
